import React, { useState, useEffect } from "react";
import profile from "../../../assets/images/Profile.png";
import { Icon } from "@iconify/react";
import Dashboard from "../../Dashboard";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
function Navbar({ show, setshow, email, hide }) {
  const [showdropdown, setshowdropdown] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [routeName, setRouteName] = useState("");
  const [routeColor, setRouteColor] = useState("");
  const [imageholder, setImageholder] = useState("");
  const { id } = useParams();
  const role = secureLocalStorage.getItem("role");
  const routeColors = {
    "/dashboard": "#ecebe4",
    "/profile": "#6B2B4B",
  };

  useEffect(() => {
    setImageholder(email.image_base64);
    console.log(imageholder);
  }, [email]);

  useEffect(() => {
    setRouteName(location.pathname);
    setRouteColor(routeColors[location.pathname]);
  }, [location]);

  return (
    <div>
      <div className="navbar p flex justify-between items-center px-3 py-3 lg:px-10   sm:py-0 sm:px-6">
        {/* 

          <div className="search_bar bg-searchbar w-2/6 hidden md:flex items-center px-5 !py-4 !gap-3 !rounded-full">
            <Icon
              icon="ri:search-line"
              className=" cursor-pointer"
              color="#ccdbeb"
              width="20"
              height="20"
            />
            <input
              type="text"
              className=" bg-transparent !focus:outline-none border-none w-full  placeholder-placeholderColor p-0 focus:ring-0"
              placeholder="Search for something"
            />
          </div> */}
        <div className="navbar-inner heading flex items-center gap-3 primary text-2xl md:text-4xl font-semibold Rubik ">
          <Icon
            icon="charm:menu-hamburger"
            width="40"
            height="40"
            color="#d76e3e"
            className="lg:hidden block"
            onClick={() => {
              setshow(!show);
            }}
          />
        </div>

        <div
          className="flex gap-3 items-center cursor-pointer "
          onClick={() => {
            setshowdropdown(!showdropdown);
          }}
        >
          <div className="profile w-14 cursor-pointer ">
            <img
              src={
                email.image_base64 && email.image_base64 != "Null"
                  ? email.image_base64
                  : profile
              }
              alt=""
              className="h-full w-full rounded-full"
            />{" "}
          </div>
          <div className="">
            <Icon
              icon="gridicons:dropdown"
              width="35"
              height="35"
              color="#6B2B4B"
            />
          </div>
        </div>

        <div
          className={`dropdown  absolute top-[100px] right-11   w-[176px] bg-[]  flex-col gap-1 justify-center rounded-[9px] items-center ${
            showdropdown ? "flex" : "hidden"
          }`}
        >
          <p className=" w-full py-1 px-3 name text-[#6B2B4B] text-base cursor-pointer">
            Hey {email.username != "Null" ? email.username : "User"}
          </p>
          <div
            className="edit flex gap-3 justify-start items-center pb-1 ps-2 w-full "
            onClick={() => {
              role == "user"
                ? navigate(`/userprofile/${id}`)
                : navigate(`/setting/${id}`);
            }}
          >
            <Icon
              icon="iconamoon:profile-fill"
              width="16"
              height="16"
              color="#6B2B4B"
              className=" cursor-pointer "
            />
            <p className=" text-[#6B2B4B] text-base cursor-pointer  ">
              Profile
            </p>
          </div>
        </div>
      </div>
      {!hide && (
        <div className=" flex items-center lg:ml-8 mb-3 px-5 py-4 md:px-10 rounded-lg  sm:p-0 sm:px-3 heading-bg">
          <div className="h-color flex items-center gap-3  text-1xl md:text-4xl font-semibold Campton ">
            {routeName === `/dashboard/${id}`
              ? "Dashboard"
              : routeName === `/vendor/${id}`
              ? "Vendors"
              : routeName === `/product/${id}`
              ? "Products"
              : routeName === `/setting/${id}`
              ? "Settings"
              : routeName === `/userDashboard/${id}`
              ? "UserDashboard"
              : routeName === `/account/${id}`
              ? "User Settings"
              : "Unknown Route"}
          </div>
        </div>
      )}
    </div>
  );
}

export default Navbar;
